// src/pages/Login/FindPassword.js
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './Login.module.scss';
import { findPassword } from '../../store/session/action';
import { Link } from 'react-router-dom';
import GuestNaviBar from '../Guest/Navigator/GuestNaviBar';
import { emailPattern } from '../../utils/convertUtil';
import { apiErrorText } from '../../utils/apiError';

const FindPassword = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [username, setUsername] = useState('');
  const [tempPassword, setTempPassword] = useState('');
  const [isError, setIsError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [emailIsEmpty, setEmailIsEmpty] = useState('');
  // 아이디 칸 아래에 붙는 오류인지, 폼 전체 오류인지를 구분합니다. 예전에는
  // errorMessage 문자열을 'Username is required.' 와 비교해 구분했는데, 문구를
  // 번역하면 그 비교가 깨지므로 별도 플래그로 뺐습니다.
  const [usernameRequired, setUsernameRequired] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === 'email') {
      setEmail(value);
      if (!value) {
        setEmailIsEmpty(t('auth.err.emailEmpty'));
        setIsError(true);
        setErrorMessage(t('auth.err.emailEmpty'));
      } else if (!emailPattern.test(value)) {
        setEmailIsEmpty(t('auth.err.emailInvalid'));
        setIsError(true);
        setErrorMessage(t('auth.err.emailInvalid'));
      } else {
        setEmailIsEmpty('');
        setIsError(false);
        setErrorMessage('');
      }
    } else if (name === 'username') {
      setUsername(value);
      setUsernameRequired(!value);
      setIsError(!value);
      setErrorMessage('');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsError(false);
    setErrorMessage('');
    setUsernameRequired(false);

    if (!email) {
      setEmailIsEmpty(t('auth.err.emailEmpty'));
      setIsError(true);
      setErrorMessage(t('auth.err.emailEmpty'));
      return;
    } else if (!emailPattern.test(email)) {
      setEmailIsEmpty(t('auth.err.emailInvalid'));
      setIsError(true);
      setErrorMessage(t('auth.err.emailInvalid'));
      return;
    }

    if (!username) {
      setIsError(true);
      setUsernameRequired(true);
      return;
    }

    try {
      const response = await findPassword({ email, username });
      if (response.status === 200 && response.tempPassword) {
        setTempPassword(response.tempPassword);
      } else {
        setIsError(true);
        // postData 는 HTTP 오류를 던지지 않고 AxiosError 를 그대로 돌려주므로
        // 실패는 catch 가 아니라 여기로 옵니다. response.message 를 그대로 쓰면
        // "Request failed with status code 400" 이 사용자에게 노출됩니다.
        setErrorMessage(apiErrorText(response, 'auth.err.incorrectUsername'));
      }
    } catch (error) {
      setIsError(true);
      setErrorMessage(apiErrorText(error, 'auth.err.generic'));
    }
  };

  return (
    <>
      <GuestNaviBar />
      <div className={styles.loginContainer}>
        <div className={styles.loginBox}>
          <h2 className={styles.loginTitle}>{t('auth.findPassword.title')}</h2>
          {tempPassword ? (
            <p className={styles.successMessageLarge}>
              <span className={styles.messagePrefix}>
                {t('auth.findPassword.tempPasswordPrefix')}
              </span>
              <span className={styles.username}>{tempPassword}</span>
            </p>
          ) : (
            <form onSubmit={handleSubmit}>
              <div className={styles.inputContainer}>
                <input
                  type="email"
                  placeholder={t('auth.field.email')}
                  name="email"
                  value={email}
                  onChange={handleInputChange}
                  className={styles.noeye_inputField}
                />
                {emailIsEmpty && (
                  <p className={styles.loginErrorMessage}>{emailIsEmpty}</p>
                )}
              </div>
              <div className={styles.inputContainer}>
                <input
                  type="text"
                  placeholder={t('auth.field.username')}
                  name="username"
                  value={username}
                  onChange={handleInputChange}
                  className={styles.noeye_inputField}
                />
                {usernameRequired && (
                  <p className={styles.loginErrorMessage}>
                    {t('auth.err.usernameRequired')}
                  </p>
                )}
              </div>
              <button type="submit" className={styles.loginButton}>
                {t('auth.findPassword.button')}
              </button>
            </form>
          )}
          {isError && errorMessage && !usernameRequired && (
            <p className={styles.loginErrorMessage}>{errorMessage}</p>
          )}
          <p className={styles.loginText}>
            {t('auth.findPassword.rememberPassword')}{' '}
            <Link to="/login" className={styles.loginLink}>
              {t('auth.findPassword.login')}
            </Link>
          </p>
        </div>
      </div>
    </>
  );
};

export default FindPassword;
